module.exports = __webpack_public_path__ + "media/video.048018f6.mp4";